module.exports = "img/flags/CK.de5a831.png";